import { createFileRoute } from "@tanstack/react-router"

import { FleetPanel } from "@/pages/FleetPanel"

export const Route = createFileRoute("/agents/fleet")({
  component: FleetPanel,
})
